import PropTypes from 'prop-types';
import { Skeleton, Row, Card, Col, Typography, Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { CardTitle } from '../../../../../components/CardTitle/CardTitle';

const { Text } = Typography;

const CommentInfoCards = ({
  t,
  isLoading,
  pensioner,
  setOpenEditCommentModal
}) => (
  <Card
    title={
      <CardTitle icon="message">{t('pensioners.show.comment_info')}</CardTitle>
    }
    className="form-card"
    extra={
      <Button
        type="link"
        className="form-button"
        aria-label={t('pensioners.show.edit_comment')}
        onClick={() => setOpenEditCommentModal(true)}
      >
        <EditOutlined />
      </Button>
    }
  >
    <Row gutter={[0, 24]}>
      <Col xs={24} xxl={24}>
        <Skeleton active loading={isLoading} paragraph={{ rows: 5 }}>
          <Text>{pensioner.comment || ''}</Text>
        </Skeleton>
      </Col>
    </Row>
  </Card>
);

export default CommentInfoCards;

CommentInfoCards.propTypes = {
  t: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  pensioner: PropTypes.shape({
    comment: PropTypes.string
  }).isRequired,
  setOpenEditCommentModal: PropTypes.func.isRequired
};
